import { render, staticRenderFns } from "./BuyModal.vue?vue&type=template&id=a2597928&scoped=true"
import script from "./BuyModal.vue?vue&type=script&lang=js"
export * from "./BuyModal.vue?vue&type=script&lang=js"
import style0 from "./BuyModal.vue?vue&type=style&index=0&id=a2597928&prod&scoped=true&lang=scss"
import style1 from "./BuyModal.vue?vue&type=style&index=1&id=a2597928&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2597928",
  null
  
)

export default component.exports